import { createToken, encryptUsing } from './utils';
import { IFiservTokenizeParams, IFiservTokenizeReturns } from './types';
import { FISERV_TOKEN_TYPE, FISERV_ACCOUNT_TYPE } from './constants';

export class Fiserv {
  static async tokenize(params: IFiservTokenizeParams): Promise<IFiservTokenizeReturns> {
    const { algorithm, publicKey, baseUrl, apiKey, oAuthToken, fdCustomerId, ...cardInfo } = params;
    const encrypt = encryptUsing(algorithm, publicKey);

    const [cardNumber, month, year, securityCode] = await Promise.all([
      encrypt(cardInfo.cardNumber),
      encrypt(cardInfo.expirationDateMonth),
      encrypt(cardInfo.expirationDateYear),
      encrypt(cardInfo.cvv),
    ]);

    const tokenResponse = await createToken({
      baseUrl,
      apiKey,
      oAuthToken,
      body: {
        fdCustomerId,
        referenceToken: { tokenType: FISERV_TOKEN_TYPE },
        account: {
          type: FISERV_ACCOUNT_TYPE,
          credit: {
            cardNumber,
            securityCode,
            expiryDate: { month, year },
            cardType: cardInfo.cardType.toUpperCase(),
            nameOnCard: cardInfo.cardholderName,
            billingAddress: { postalCode: cardInfo.zipCode },
          },
        },
      },
    });

    const nonce = JSON.stringify((await tokenResponse.json()).token);

    return {
      nonce,
    };
  }
}
